<template>
    <div class="common-document-link">
        <div class="common-document-link__icon">
            <icon name="document"/>
        </div>
        <a class="common-document-link__title"
           v-bind:href="href"
           v-bind:target="target"
           v-text="title"
        />
    </div>
</template>

<script>
export default {
    name: 'common-document-link',
    props: {
        title: {
            type: String,
            default: '',
        },
        href: {
            type: String,
            default: '',
        },
        target: {
            type: String,
            default: '_blank',
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-document-link {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &__icon {
        margin-right: 8px;
        font-size: 1.8rem;
    }

    &__title {
        .typography-body();

        display: block;
        line-height: 20px;
        text-decoration: underline;
    }
}
</style>
